<app-header [enableBack]="false">
  <div title>
    {{ 'chargeInformation.title' | translate }}
  </div>
</app-header>

<div class="p-6">
  <form [formGroup]="queryForm">
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.chargeType' | translate }}</label>
            <select appSelect [autofocus]="true" formControlName="chargeType" [collection]="chargeTypeOptions">
            </select>
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.chargeTypeId' | translate }}</label>
            <input type="text" appInput formControlName="chargeTypeId" [placeholder]="'chargeInformation.chargeTypeId' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.description' | translate }}</label>
            <input type="text" appInput formControlName="title" [placeholder]="'chargeInformation.description' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.dataHubStatus' | translate }}</label>
            <select appSelect formControlName="dataHubStatus" [collection]="dataHubStatusOptions">
            </select>
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.validFrom' | translate }}</label>
            <input type="date" appInputDate [defaultDate]="null" formControlName="validFrom">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.validTo' | translate }}</label>
            <input type="date" appInputDate [defaultDate]="null" formControlName="validTo">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'chargeInformation.dataHub' | translate }}</label>
            <select appSelect formControlName="existsInDataHub" [collection]="existsInDataHubOptions">
            </select>
          </app-input-group>
        </div>
        <div class="w-1/4"></div>
      </div>
      <button appButton (click)="table.search()">{{ 'common.search' | translate }}</button>
    </app-card>
  </form>


  <app-table
    #table
    [config]="chargeInformationTableConfig"
    [(selectedElements)]="selectedElements"></app-table>
</div>
